import { RoutesConfig } from '../../../config/router/router';
import LazyLoad from '../../../core/common/LazyLoading/LazyLoading';
import { routes } from '../../../config/routes/routes';
import NotFoundPage from '../../../core/pages/error/NotFoundPage/NotFoundPage';
import React from 'react';

/* eslint-disable new-cap */
const CategoriesPage = LazyLoad(
  () =>
    import('../../../app/pages/admin/Category/CategoriesPage/CategoriesPage'),
);
const ArticleCategoriesPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/ArticleCategory/ArticleCategoriesPage/ArticleCategoriesPage'
    ),
);
const ArticleCategoriesCreatePage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/ArticleCategory/ArticleCategoryCreatePage/ArticleCategoryCreatePage'
    ),
);
const ArticleCategoriesEditPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/ArticleCategory/ArticleCategoryEditPage/ArticleCategoryEditPage'
    ),
);
const CategoryEditPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/Category/CategoryEditPage/CategoryEditPage'
    ),
);

const BrandsPage = LazyLoad(
  () => import('../../../app/pages/admin/Brand/BrandsPage/BrandsPage'),
);
const BrandEditPage = LazyLoad(
  () => import('../../../app/pages/admin/Brand/BrandEditPage/BrandEditPage'),
);

const ManufacturersPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/Manufacturer/ManufacturersPage/ManufacturersPage'
    ),
);
const ManufacturerEditPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/Manufacturer/ManufacturerEditPage/ManufacturerEditPage'
    ),
);

const VehiclesPage = LazyLoad(
  () => import('../../../app/pages/admin/Vehicle/VehiclesPage/VehiclesPage'),
);

const ProductsPage = LazyLoad(
  () => import('../../../app/pages/admin/Product/ProductsPage/ProductsPage'),
);
const ProductEditPage = LazyLoad(
  () =>
    import('../../../app/pages/admin/Product/ProductEditPage/ProductEditPage'),
);

const BlogsPage = LazyLoad(
  () => import('../../../app/pages/admin/Blog/BlogsPage/BlogsPage'),
);
const BlogCreatePage = LazyLoad(
  () => import('../../../app/pages/admin/Blog/BlogCreatePage/BlogCreatePage'),
);
const BlogEditPage = LazyLoad(
  () => import('../../../app/pages/admin/Blog/BlogEditPage/BlogEditPage'),
);
const PromoCodesPage = LazyLoad(
  () =>
    import('../../../app/pages/admin/PromoCode/PromoCodesPage/PromoCodesPage'),
);
const PromoCodeCreatePage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/PromoCode/PromoCodeCreatePage/PromoCodeCreatePage'
    ),
);
const PromoCodeEditPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/PromoCode/PromoCodeEditPage/PromoCodeEditPage'
    ),
);

const StaticPagesPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/StaticPage/StaticPagesPage/StaticPagesPage'
    ),
);
const StaticPageEditPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/StaticPage/StaticPageEditPage/StaticPageEditPage'
    ),
);
const PriceVariantsPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/PriceVariant/PriceVariantsPage/PriceVariantsPage'
    ),
);
const PriceVariantCreatePage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/PriceVariant/PriceVariantCreatePage/PriceVariantCreate'
    ),
);
const PriceVariantEditPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/PriceVariant/PriceVariantEditPage/PriceVariantEditPage'
    ),
);
const ClientsPage = LazyLoad(
  () => import('../../../app/pages/admin/Client/ClientsPage/ClientsPage'),
);
const ClientCreatePage = LazyLoad(
  () =>
    import('../../../app/pages/admin/Client/ClientCreatePage/ClientCreatePage'),
);
const ClientEditPage = LazyLoad(
  () => import('../../../app/pages/admin/Client/ClientEditPage/ClientEditPage'),
);
const ClientRepresentativeCreatePage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/ClientRepresentative/ClientRepresentativeCreatePage/ClientRepresentativeCreatePage'
    ),
);
const ClientRepresentativeEditPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/ClientRepresentative/ClientRepresentativeEditPage/ClientRepresentativeEditPage'
    ),
);
const OrdersPage = LazyLoad(
  () => import('../../../app/pages/admin/Order/OrdersPage/OrdersPage'),
);

const VatRatesPage = LazyLoad(
  () => import('../../../app/pages/admin/VatRate/VatRatesPage/VatRatesPage'),
);
const VatRateEditPage = LazyLoad(
  () =>
    import('../../../app/pages/admin/VatRate/VatRateEditPage/VatRateEditPage'),
);

const BasketsPage = LazyLoad(
  () => import('../../../app/pages/admin/Basket/BasketsPage/BasketsPage'),
);

const FaqPage = LazyLoad(
  () => import('../../../app/pages/admin/Faq/FaqPage/FaqPage'),
);
const FaqCreatePage = LazyLoad(
  () => import('../../../app/pages/admin/Faq/FaqCreatePage/FaqCreatePage'),
);
const FaqEditPage = LazyLoad(
  () => import('../../../app/pages/admin/Faq/FaqEditPage/FaqEditPage'),
);

const LowStockAlertsPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/LowStockAlert/LowStockAlertsPage/LowStockAlertsPage'
    ),
);

const ReturnOrdersPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/ReturnOrder/ReturnOrdersPage/ReturnOrdersPage'
    ),
);
const ReturnOrderCreatePage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/ReturnOrder/ReturnOrderCreatePage/ReturnOrderCreatePage'
    ),
);
const ReturnOrderEditPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/ReturnOrder/ReturnOrderEditPage/ReturnOrderEditPage'
    ),
);

const OrderPage = LazyLoad(
  () => import('../../../app/pages/admin/Order/OrdersPage/OrderPage/OrderPage'),
);

const DeliveryPricesPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/DeliveryPrice/DeliveryPricesPage/DeliveryPricesPage'
    ),
);
const DeliveryPriceEditPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/DeliveryPrice/DeliveryPriceEditPage/DeliveryPriceEditPage'
    ),
);
const ManualEmailCreatePage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/ManualEmails/ManualEmailCreatePage/ManualEmailCreatePage'
    ),
);

export const APP_ROUTER_CONFIG: RoutesConfig = {
  auth: [],
  authNonAuth: [],
  admin: [
    {
      path: routes.admin.manualEmails.create,
      element: <ManualEmailCreatePage />,
    },
    {
      path: routes.admin.categories.list,
      element: <CategoriesPage />,
    },
    {
      path: routes.admin.articleCategories.list,
      element: <ArticleCategoriesPage />,
    },
    {
      path: routes.admin.articleCategories.new,
      element: <ArticleCategoriesCreatePage />,
    },
    {
      path: routes.admin.articleCategories.edit,
      element: <ArticleCategoriesEditPage />,
    },
    {
      path: routes.admin.categories.edit,
      element: <CategoryEditPage />,
    },
    {
      path: routes.admin.brands.list,
      element: <BrandsPage />,
    },
    {
      path: routes.admin.brands.edit,
      element: <BrandEditPage />,
    },
    {
      path: routes.admin.manufacturers.list,
      element: <ManufacturersPage />,
    },
    {
      path: routes.admin.manufacturers.edit,
      element: <ManufacturerEditPage />,
    },
    {
      path: routes.admin.vehicles.list,
      element: <VehiclesPage />,
    },
    {
      path: routes.admin.products.list,
      element: <ProductsPage />,
    },
    {
      path: routes.admin.products.edit,
      element: <ProductEditPage />,
    },
    {
      path: routes.admin.blogs.list,
      element: <BlogsPage />,
    },
    {
      path: routes.admin.blogs.new,
      element: <BlogCreatePage />,
    },
    {
      path: routes.admin.blogs.edit,
      element: <BlogEditPage />,
    },
    {
      path: routes.admin.staticPages.list,
      element: <StaticPagesPage />,
    },
    {
      path: routes.admin.staticPages.edit,
      element: <StaticPageEditPage />,
    },
    {
      path: routes.admin.orders.list,
      element: <OrdersPage />,
    },
    {
      path: routes.admin.vatRates.list,
      element: <VatRatesPage />,
    },
    {
      path: routes.admin.vatRates.edit,
      element: <VatRateEditPage />,
    },
    {
      path: routes.admin.baskets.list,
      element: <BasketsPage />,
    },
    {
      path: routes.admin.faq.list,
      element: <FaqPage />,
    },
    {
      path: routes.admin.faq.new,
      element: <FaqCreatePage />,
    },
    {
      path: routes.admin.faq.edit,
      element: <FaqEditPage />,
    },
    {
      path: routes.admin.lowStockAlerts.list,
      element: <LowStockAlertsPage />,
    },
    {
      path: routes.admin.returnOrders.list,
      element: <ReturnOrdersPage />,
    },
    {
      path: routes.admin.returnOrders.new,
      element: <ReturnOrderCreatePage />,
    },
    {
      path: routes.admin.returnOrders.edit,
      element: <ReturnOrderEditPage />,
    },
    {
      path: routes.admin.priceVariants.list,
      element: <PriceVariantsPage />,
    },
    {
      path: routes.admin.priceVariants.new,
      element: <PriceVariantCreatePage />,
    },
    {
      path: routes.admin.priceVariants.edit,
      element: <PriceVariantEditPage />,
    },
    {
      path: routes.admin.clients.list,
      element: <ClientsPage />,
    },
    {
      path: routes.admin.clients.new,
      element: <ClientCreatePage />,
    },
    {
      path: routes.admin.clients.edit,
      element: <ClientEditPage />,
    },
    {
      path: routes.admin.clientRepresentatives.new,
      element: <ClientRepresentativeCreatePage />,
    },
    {
      path: routes.admin.clientRepresentatives.edit,
      element: <ClientRepresentativeEditPage />,
    },
    {
      path: routes.admin.promoCodes.list,
      element: <PromoCodesPage />,
    },
    {
      path: routes.admin.promoCodes.new,
      element: <PromoCodeCreatePage />,
    },
    {
      path: routes.admin.promoCodes.edit,
      element: <PromoCodeEditPage />,
    },
    {
      path: routes.admin.orders.details,
      element: <OrderPage />,
    },
    {
      path: routes.admin.deliveryPrices.list,
      element: <DeliveryPricesPage />,
    },
    {
      path: routes.admin.deliveryPrices.edit,
      element: <DeliveryPriceEditPage />,
    },
    {
      path: '*',
      element: <NotFoundPage />,
    },
  ],
  adminNonAuth: [],
};
